export default __webpack_public_path__ + "static/media/jr_lobstersona.2dfaf36d.png";